import React from "react"
import styled from "styled-components"
import { MediaUrlType } from "../../types/discovery/Content/MediaUrl/MediaUrlType"
import { ButterCmsErrorBoundary } from "../ButterCmsErrorBoundary"

export type MediaRendererProps = {
  type: MediaUrlType
  url: string
  className?: string
}

const COMPONENT_NAME = "MediaUrlRenderer"

export const MediaUrlRenderer = (props: MediaRendererProps) => {
  const { type, url, className } = props

  return (
    <ButterCmsErrorBoundary componentName={COMPONENT_NAME}>
      {type === MediaUrlType.Image && <Img className={className} src={url} alt="image" />}
      {type === MediaUrlType.Video && (
        <IFrameContainer>
          <iframe className={className} src={url} frameBorder="0" allowFullScreen />
        </IFrameContainer>
      )}
    </ButterCmsErrorBoundary>
  )
}

const Img = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 445px;
`

const IFrameContainer = styled.div`
  overflow: hidden;
  /* 16:9 aspect ratio */
  padding-top: 56.25%;
  position: relative;

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`
